import { render } from "./PhaseDashboard.vue?vue&type=template&id=6fc10c0c&ts=true"
import script from "./PhaseDashboard.vue?vue&type=script&lang=ts"
export * from "./PhaseDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__